const getUpdatedQuery = (filter) => {
  const selectedItems = filter.selectedItems || [];

  if (selectedItems.length === 0) {
    return { [filter.id]: undefined };
  }

  return { [filter.id]: selectedItems.join(",") };
};

const update = (filter, query, { selectedMainCategories, selectedSubCategories }) => {
  let queryValue = query[filter.id];

  if (filter.id === "main-categories" && selectedMainCategories) {
    queryValue = selectedMainCategories.join(",");
  }

  if (filter.id === "sub-categories" && selectedSubCategories) {
    queryValue = selectedSubCategories.join(",");
  }

  const selectedItems = queryValue ? queryValue.split(",") : [];

  return {
    ...filter,
    selectedItems,
  };
};

const clear = (filter) => {
  return {
    ...filter,
    selectedItems: [],
  };
};

const count = (filter) => {
  return filter.selectedItems?.length > 0 ? 1 : 0;
};

const handleSelectionChange = (filter, { selectedItems }) => {
  return {
    ...filter,
    selectedItems,
  };
};

const clearGroup = (filters, id) => {
  return filters.map((filter) => {
    if (filter.id === id) {
      return clear(filter);
    }

    return filter;
  });
};

export const checkboxFilterHelper = {
  getUpdatedQuery,
  update,
  clear,
  clearGroup,
  count,
  handleSelectionChange,
};
